import React, { useEffect, useState } from "react";
import {
    Button,
    Card,
    CardBody,
    CardTitle,
    Col,
    Container,
    Input,
    Label,
    Row,
    TabContent,
    TabPane,
    Form,
    FormGroup,
    Option,
} from "reactstrap";
import Breadcrumbs from '../../components/Common/Breadcrumb';

const SellCar = () => {

    const API_URL = process.env.REACT_APP_APIURL;

    const breadcrumbItems = [
        { title: "Home", link: "/" },
        { title: "Sell Your Car", link: "#" },
    ];

    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [sellInquiry, updateInquiry] = useState([]);
    const [expandedSpec, setExpandedSpec] = useState(null);

    const fetchData = async () => {
        try {
            setLoading(true);
            const response = await fetch(`${API_URL}/sellYourCar`);
            if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);

            const data = await response.json();

            updateInquiry(data.data || []);

        } catch (err) {
            console.error("Error fetching data:", err);
            setError("Failed to fetch data");
        } finally {
            setLoading(false);
        }
    };

    const toggleExpand = (id) => {
        setExpandedSpec(expandedSpec === id ? null : id);
    };

    useEffect(() => {
        fetchData();
    }, []);

    return (
        <>
            <div className="page-content">
                <Container fluid className="py-4">
                    <Breadcrumbs
                        title="Sell Your Car"
                        breadcrumbItems={breadcrumbItems}
                    />
                    <Card>
                        <CardBody>
                            <div className="table-responsive">
                                <table className="table table-centered align-middle table-nowrap mb-0 table-bordered">
                                    <thead className="table-light text-muted">
                                        <tr>
                                            <th>ID</th>
                                            <th>Make</th>
                                            <th>Model</th>
                                            <th>Variant</th>
                                            <th>Year</th>
                                            <th>Fuel</th>
                                            <th>Actions</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {loading ? (
                                            <tr>
                                                <td colSpan="5" className="text-center">Loading...</td>
                                            </tr>
                                        ) : error ? (
                                            <tr>
                                                <td colSpan="5" className="text-center text-danger">{error}</td>
                                            </tr>
                                        ) : sellInquiry.length > 0 ? (
                                            sellInquiry.map((el, index) => (
                                                <React.Fragment key={index}>
                                                    <tr>
                                                        <td>{index + 1}</td>
                                                        <td>{el.make}</td>
                                                        <td>{el.model}</td>
                                                        <td>{el.variant || '--'}</td>
                                                        <td>{el.year}</td>
                                                        <td>{el.fuel}</td>
                                                        <td>
                                                            <button className="btn btn-sm btn-light me-2" onClick={() => toggleExpand(el._id)}>
                                                                <i className={`mdi mdi-chevron-${expandedSpec === el._id ? 'up' : 'down'} font-size-18`}></i>
                                                            </button>
                                                        </td>
                                                    </tr>
                                                    {expandedSpec === el._id && (
                                                        <>
                                                            <tr className="bg-light">
                                                                <td colSpan="7" className="font-weight-bold">More Information</td>
                                                            </tr>
                                                            <tr>
                                                                <td>Transmission</td>
                                                                <td>{el.transmission}</td>
                                                            </tr>
                                                            <tr>
                                                                <td>kmsDriven</td>
                                                                <td>{el.kmsDriven}</td>
                                                            </tr>
                                                            <tr>
                                                                <td>RegNumber</td>
                                                                <td>{el.regNumber || '--'}</td>
                                                            </tr>
                                                            <tr>
                                                                <td>Location</td>
                                                                <td>{el.location}</td>
                                                            </tr>
                                                            <tr>
                                                                <td>Owners</td>
                                                                <td>{el.owners}</td>
                                                            </tr>
                                                            <tr>
                                                                <td>Insurance</td>
                                                                <td>{el.insurance}</td>
                                                            </tr>
                                                            <tr>
                                                                <td>RcAvailable</td>
                                                                <td>{el.rcAvailable}</td>
                                                            </tr>
                                                            <tr>
                                                                <td>LoanOnCar</td>
                                                                <td>{el.loanOnCar}</td>
                                                            </tr>
                                                            <tr>
                                                                <td>ServiceHistory</td>
                                                                <td>{el.serviceHistory}</td>
                                                            </tr>
                                                            <tr>
                                                                <td>Price</td>
                                                                <td>{el.price}</td>
                                                            </tr>
                                                            <tr>
                                                                <td>Name</td>
                                                                <td>{el.name}</td>
                                                            </tr>
                                                            <tr>
                                                                <td>Phone</td>
                                                                <td>{el.phone}</td>
                                                            </tr>
                                                            <tr>
                                                                <td>Email</td>
                                                                <td>{el.email}</td>
                                                            </tr>
                                                            <tr>
                                                                <td>Contact Time</td>
                                                                <td>{el.contactTime || '--'}</td>
                                                            </tr>
                                                        </>
                                                    )}
                                                </React.Fragment>
                                            ))
                                        ) : (
                                            <tr>
                                                <td colSpan="5" className="text-center">No records found</td>
                                            </tr>
                                        )}
                                    </tbody>
                                </table>
                            </div>
                        </CardBody>
                    </Card>
                </Container>
            </div>
        </>
    )
}

export default SellCar;